export default __webpack_public_path__ + "static/media/Discord.0016995b.svg";